import { AxiosInstance } from "axios"
import { ApiResponse } from "../../models/api"
import { WeightClass } from "../../models/weight-class"

export interface GetWeightClassesParams {
    limit?: number
    page?: number
    paginate?: boolean
    teamId?: string
    teamIds?: string
}

export class WeightClassesApi {
    private client: AxiosInstance

    constructor(client: AxiosInstance) {
        this.client = client
    }

    getWeightClasses = (params?: GetWeightClassesParams) =>
        this.client.get<ApiResponse<WeightClass>>("weightclasses", {
            params: {
                limit: params?.limit ?? 20,
                page: params?.page ?? 1,
                paginate: params?.paginate ?? true,
                teamId: params?.teamId ?? "",
                teamIds: params?.teamIds ?? "",
            },
        })
}
